import { defineComponent } from 'vue';

import header_top from "./header.vue";
import booking_details from "./booking_details.vue";
import booking_documentation from "./booking_documentation.vue";
import booking_notes from "./booking_notes.vue";
import passengers from "./passengers.vue";

export default defineComponent({
    components: {
        header_top,
        booking_details,
        booking_documentation,
        booking_notes,
        passengers
    },
    props: {
        in_dialog: {
            type: Boolean,
            default: false
        }
    },
    emits: ['booking_cancelled'],
    methods: {
        Relay_Cancelled(all_cancelled: boolean) {
            this.$emit('booking_cancelled', all_cancelled);
        }
    }
});
